import { Select } from "antd";
import React, { useEffect, useState } from "react";
import "../style.css";
import uuidv4 from "uuid/v4";
import { useDispatch } from "react-redux";
import { createWithholding, getWithholdingsList, updateWithholding } from "../../../../store/actions/precog/withholding";

const Option = Select.Option;

const SearchedAccount = ({
  searchedWithholdings,
  withholding,
  withHoldingNew,
  setWithHoldingNew,
  docTotal,
  docDetail,
  totalTaxable
}) => {
  const dispatch = useDispatch();

  const [newTitle, setNewTitle] = useState(withholding.title);

  useEffect(() => {    
    setNewTitle(withholding.description.trim().charAt(0)?.toUpperCase() + withholding.description?.trim()?.slice(1).toLocaleLowerCase());
  }, [withholding.description]);
  
  return (
    <Select
      showSearch
      style={{width: "80%"}}
      suffixIcon={<></>}
      optionFilterProp="children"
      getPopupContainer={trigger => trigger.parentNode}
      filterOption={(input, option) => {
        return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }        
      }
      onSearch={value => setNewTitle(value)}
      onSelect={value => {   
        let currentItem = searchedWithholdings.find(el => el.reasonId === value);
        let itemIndex = withHoldingNew.findIndex(item => item.uuid === withholding.uuid);
        if (withHoldingNew[itemIndex].description === "") {
          dispatch(createWithholding(docDetail.id,
            {
              description: currentItem.description,
              reasonId: currentItem.reasonId,
              cuReason: currentItem.cuReason,
              withholdingRate: currentItem.withholdingRate/* ,
              amount: Math.round((baseTotal - rateTotal) * 100) / 100*/
            })).then(res => {
            withHoldingNew[itemIndex].uuid = res;
            /** ricarico perché ho bisogno dei calcoli */
            dispatch(getWithholdingsList(docDetail.id));
          });
        } else {
          dispatch(updateWithholding(
            docDetail.id,
            withHoldingNew[itemIndex].uuid,
            {
              cashContribution: withholding.cashContribution,
              notIncomeAmount: withholding.notIncomeAmount,
              totalNetAmount: totalTaxable,
              cuReason: currentItem.cuReason,
              reasonId: currentItem.reasonId,
              description: currentItem.description,
              withholdingRate: currentItem.withholdingRate/* ,
              amount: baseTotal - rateTotal*/
            }
          )).then(() => {
            /** ricarico perché ho bisogno dei calcoli */
            dispatch(getWithholdingsList(docDetail.id));
          });
        }
        setNewTitle(value);
        /*     
        let currentItem = searchedWithholdings.find(el => el.reasonId === value);
        if (withHoldingNew.find(el => el.reasonId === withholding.reasonId)) {
          let baseTotal = (docTotal * currentItem.baseTaxableAmount) / 100;
          let rateTotal = (baseTotal * currentItem.withholdingRate) / 100;
          let itemIndex = withHoldingNew.findIndex(item => item.uuid === withholding.uuid);
          let clonedWithHoldings = [...withHoldingNew];
          if (withHoldingNew[itemIndex].description === "") {
            dispatch(createWithholding(docDetail.id,
              {
                description: currentItem.description,
                reasonId: currentItem.reasonId,
                cuReason: currentItem.cuReason,
                withholdingRate: currentItem.withholdingRate,
                amount: Math.round((baseTotal - rateTotal) * 100) / 100
              })).then(res => withHoldingNew[itemIndex].uuid = res);
          } else {
            dispatch(updateWithholding(
              docDetail.id,
              withHoldingNew[itemIndex].uuid,
              {
                cuReason: currentItem.cuReason,
                reasonId: currentItem.reasonId,
                description: currentItem.description,
                withholdingRate: currentItem.withholdingRate,
                amount: baseTotal - rateTotal
              }
            ));
          }
          clonedWithHoldings[itemIndex].description = currentItem.description;
          clonedWithHoldings[itemIndex].reasonId = currentItem.reasonId;
          clonedWithHoldings[itemIndex].cuReason = currentItem.cuReason;
          clonedWithHoldings[
            itemIndex
          ].title = `${currentItem.reasonId} - ${currentItem.description}`;
          clonedWithHoldings[itemIndex].withholdingRate = currentItem.withholdingRate;
          clonedWithHoldings[itemIndex].baseTaxableAmount = baseTotal;
          clonedWithHoldings[itemIndex].amount = baseTotal - rateTotal;
          setWithHoldingNew(clonedWithHoldings);
        }
        setNewTitle(value);
        */
      }}
      className="withholding-search"
      value={newTitle}
      placeholder="Sel. ritenuta"
      // dropdownClassName={isAccountRow ? "articles-accordion-dropdown" : "split-article-input-accordion"}
    >
      {
        searchedWithholdings?.map(el => {          
          return (
            <Option
              key={"articles-accordion-select_" + uuidv4()}
              value={el.reasonId}
            >
              {el.title}
            </Option>
          );
        })
      }        
    </Select>
  );
};

export default SearchedAccount;
